// Where the backend lives.
//
// This used to be a `const API_BASE_URL = "http://localhost:5000"` declared
// separately in 25 files, plus three relative URLs in ManagePayout that only
// resolved because of the `proxy` setting in package.json (which applies to
// `npm start` and not to a build). A deployed bundle therefore called the
// viewer's own machine. One value, read at build time, replaces all of that.
//
// Create React App inlines `process.env.REACT_APP_*` at build time, so this is
// baked into the bundle -- set it when you build, not when you serve:
//
//     REACT_APP_API_BASE_URL=https://api-dev.example.com npm run build
//
// Whatever you set here must also appear in the backend's
// CORS_ALLOWED_ORIGINS, from the other direction: that is an explicit
// allowlist of origins, not a wildcard, because these requests carry
// credentials.

const configured = (process.env.REACT_APP_API_BASE_URL || "").trim().replace(/\/+$/, "");

function resolve() {
  if (configured) return configured;

  // Development convenience only. A missing value in a production build is a
  // misconfiguration, not something to paper over with a default that points
  // at the developer's laptop -- that is the exact bug this file exists to
  // remove, and it fails silently for everyone except the developer.
  if (process.env.NODE_ENV !== "production") return "http://localhost:5000";

  // eslint-disable-next-line no-console
  console.error(
    "REACT_APP_API_BASE_URL was not set when this bundle was built. " +
      "Falling back to the page's own origin, which is almost certainly wrong. " +
      "Rebuild with REACT_APP_API_BASE_URL=https://<your-api-host>."
  );
  return window.location.origin;
}

export const API_BASE_URL = resolve();

export default API_BASE_URL;

// Stripe's PUBLISHABLE key. Not a secret -- it identifies the account to
// Stripe.js in the browser and can only create tokens, never move money. It was
// pasted into three separate files, so switching between test and live mode
// meant editing all three and hoping none was missed. The fallback keeps local
// development working with the existing test key.
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_test_51RvHRsDFfGtXoexiURAaUfOIbphUR5ji26F5MeXg0tUryoemeph24h8VExlqcn3ZKhkngR9ruZGduPHaAyKsjneh00FsQUY14G";
